import styled from "styled-components";
import indicatorArrow from "images/objectPanel/ic_scroll_indicator.svg";
const IndicatorBox = styled.div`
  height: 60px;
  width: 30px;
  background: linear-gradient(270deg, #28292f 0%, rgba(40, 41, 47, 0) 100%);
  position: absolute;
  right: ${props => (props.position === "right" ? 0 : null)};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  opacity: 0.82;
  cursor: pointer;
  transform: ${props => (props.position === "right" ? null : "rotate(180deg)")};
`;

export default function ScrollIndicator({position, onClick}) {
  return (
    <div onClick={onClick}>
      <IndicatorBox position={position}>
        <img src={indicatorArrow} alt="" />
      </IndicatorBox>
    </div>
  );
}
